<template>
    <div id="record_buy">
        <div class="record_title">购买记录</div>
        <div class="record_table" v-if="buyHistory.length == 0">
            <noData :noIndex="2" @toCreate="toCreate"></noData>
        </div>
        <div class="record_table" v-else>
            <div class="record_table_title">
                <div class="record_table_title1" v-for="(item, i) in tableTitle" :key="i">
                    {{ item }}
                </div>
            </div>
            <div class="record_table_title" v-for="(item, i) in buyHistory" :key="i">
                <div class="record_table_title1 record_table_title2">
                   {{ item.typeName }}
                </div>
                <!-- <div class="record_table_title1 record_table_title2">
                    {{ item.zhifu == 'wx' ? '微信' : '支付宝' }}
                </div> -->
                <!-- <div class="record_table_title1 record_table_title2">
                    {{ item.amount }}
                </div> -->
                <div class="record_table_title1 record_table_title2">
                    {{ item.createTime }}
                </div>
                <div class="record_table_title1 record_table_title2">
                    {{ item.expirationTime ? item.expirationTime : '永久' }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { EventBus } from '@/utils/eventBus';
import noData from './no_data.vue';
import api from '@/api/api';

export default {
    props:{
        list:{
            type:Array,
            default: () => [] // 使用工厂函数返回默认值
        }
    },
    components: {
        noData
    },
    data() {
        return {
            // tableTitle: ['购买记录', '金额', '支付时间', '到期时间'],
            tableTitle: ['购买记录', '支付时间', '到期时间'],
            buyHistory: []
        }
    },
    created(){
        this.payList()
    },
    methods:{
        toCreate(){
            EventBus.$emit('openVip')
        },
        payList(){
            api.payAPPList().then((res) =>{
                if(res.code == 200){
                   this.buyHistory = res.data
                //    console.log(res.data.orders)
                }
            })
        }
    }
}
</script>

<style scoped>
#record_buy {
    width: 100%;
    height: calc(100% + 90px);
    padding: 35px 25px;
    background-color: #FFFFFF;
    box-shadow: 0px 0 8px 0px rgba(117, 53, 0, 0.06);
    border-radius: 10px 0 0 10px;
}

.record_title {
    font-weight: bold;
    font-size: 18px;
    color: #111111;
    margin-bottom: 10px;
    display: flex;
    justify-content: space-between;
}

.record_table {
    width: 100%;
    height: calc(100% - 30px);
    overflow-y: auto;
    -ms-overflow-style: none;
    scrollbar-width: none;
}

.record_table_title {
    display: flex;

}

.record_table_title1 {
    flex: 1;
    height: 50px;
    display: flex;
    align-items: center;
    padding-left: 17px;
    font-size: 15px;
    color: #666666;
    background-color: #F5F7FA;
    border-bottom: 1px solid #E6EBF0;
    border-right: 1px solid #E6EBF0;
}
/* .record_table_title1:nth-child(1){
    flex: auto;
} */
/* .record_table_title1:nth-child(2){
    flex: 0.5 !important;
} */
.record_table_title1:nth-child(2),
.record_table_title1:nth-child(3) {
    flex: 1 !important;
}

.record_table_title1:last-child {
    border-right: none;
}

.record_table_title2 {
    background-color: #FFFFFF;
    border-right: none;
}
</style>